module.exports = __webpack_public_path__ + "media/images/360/healthy-1c4b47b5f35ecf5c9f76dd82f2600ee1.jpg";